import React, { useCallback, useEffect } from "react";
import { FieldProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { FieldLabelKeys } from '../../../enums/locales/forms';

import { Field } from '../Field';
import { Switch as StyledSwitch } from '../../styled/Switch';
import { IProps as IStyledProps } from '../../styled/Switch/Switch';

 
export interface IProps extends FieldProps, IStyledProps {
  className?: string;
  labelKey?: FieldLabelKeys;
  noBottomMargin?: boolean;
}

const Switch: React.FC<IProps> = ({
  field,
  form,
  className = '',
  labelKey,
  noBottomMargin,
  ...restProps
}) => {
  const { t } = useTranslation();
  const { name } = field;
	const { touched, isSubmitting, setFieldTouched, setFieldValue, setTouched } = form;

  const splitedName = name.split('.')[0];
  const isTouched = Boolean(touched[splitedName]);

  useEffect(() => {
    if (isSubmitting && !isTouched) {
      setFieldTouched(splitedName, true);
    }
  }, [isSubmitting, isTouched, splitedName, setFieldTouched]);

  const onChange = useCallback((value) => {
    setFieldValue(name, value);
  }, [field, name, isTouched]);

  const onBlur = useCallback(() => {
    field.onBlur({ target: { name, value: field.value } });
    setTouched({ ...touched, [name]: true });
    if (restProps.onBlur) {
      restProps.onBlur({ target: { name, value: field.value } });
    }
  }, [restProps, field, touched]);

  const label = labelKey ? t(labelKey) : '';

  return (
    <Field
      className={className}
      noBottomMargin={noBottomMargin}
    >
      <StyledSwitch
        {...field}
        {...restProps}
        onChange={onChange}
        onBlur={onBlur}
        label={label}
      />
    </Field>
  );
};

export default Switch;
